var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "start-page" } },
    [
      _setup.CurrentUser.signedIn
        ? _c(_setup.Portal, { attrs: { to: "content-header" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "ci-collapsible-header",
                    rawName: "v-ci-collapsible-header",
                  },
                ],
                key: "start-page-header",
                class: `ci-content-header ${
                  _setup.viewportService.check(["xl", "xxl"]) ? "" : "sticky"
                }`,
                attrs: { id: "start-page-header" },
              },
              [
                _c(
                  "div",
                  { staticClass: "ci-content-header__inner p-0" },
                  [
                    _c(_setup.LoggedInBanner, {
                      staticClass: "d-none d-md-flex",
                      attrs: {
                        user: _setup.CurrentUser,
                        partner: _setup.partner,
                      },
                      on: { "tracking-click": _setup.propagateTrackClick },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-tabs",
                      {
                        staticClass: "ci-tabs d-xl-none",
                        attrs: {
                          "replace-url": false,
                          "tracking-overwrites": {
                            source: { name: "StartPageHeaderTabs" },
                          },
                        },
                        model: {
                          value: _setup.currentTab,
                          callback: function ($$v) {
                            _setup.currentTab = $$v
                          },
                          expression: "currentTab",
                        },
                      },
                      [
                        _c("b-tab", {
                          attrs: {
                            id: "contentTab",
                            title: _vm.$t(
                              "ui.views.start_page.header.tabs.news"
                            ),
                            active: _setup.viewMode === "news",
                          },
                          on: {
                            click: function ($event) {
                              _setup.viewMode = "news"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: {
                            id: "productTab",
                            title: _vm.$t(
                              "ui.views.start_page.header.tabs.products"
                            ),
                            active: _setup.viewMode === "products",
                          },
                          on: {
                            click: function ($event) {
                              _setup.viewMode = "products"
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "start-page-container d-flex flex-row gap-3" }, [
        _c(
          "div",
          {
            staticClass:
              "start-page-container__mobile-view col-12 d-xl-none p-0",
          },
          [
            _setup.CurrentUser.signedIn
              ? _c(
                  "b-tabs",
                  {
                    staticClass: "ci-tabs",
                    attrs: {
                      "replace-url": false,
                      "nav-wrapper-class": "d-none",
                    },
                    model: {
                      value: _setup.currentTab,
                      callback: function ($$v) {
                        _setup.currentTab = $$v
                      },
                      expression: "currentTab",
                    },
                  },
                  [
                    _c(
                      "b-tab",
                      {
                        attrs: {
                          title: _vm.$t("ui.views.start_page.header.tabs.news"),
                          active: _setup.viewMode === "news",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "start-page-container__mobile-view__news d-flex flex-column gap-3",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "start_page-container__news" },
                              [
                                _c(_setup.News, {
                                  staticClass: "ci-content-padding",
                                  attrs: {
                                    contents: _setup.startPageContents,
                                    loading: _setup.newsLoading,
                                  },
                                  on: {
                                    "tracking-click":
                                      _setup.propagateTrackClick,
                                  },
                                }),
                                _vm._v(" "),
                                _c(_setup.PartnerCarousel, {
                                  staticClass: "pb-3 pb-md-4",
                                  attrs: {
                                    companies: _setup.partnerCompanies,
                                    loading: _setup.companiesLoading,
                                  },
                                  on: {
                                    "tracking-click":
                                      _setup.propagateTrackClick,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(_setup.CiSuggestedExternalContent, {
                              staticClass: "pb-0",
                              attrs: {
                                id: `start_page_${
                                  _setup.CurrentUser.signedIn
                                    ? "logged_in"
                                    : "guest"
                                }_header_mobile_news`,
                                type: "display",
                                "member-ad": _setup.CurrentUser.signedIn,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.Notifications, {
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.Event, {
                              staticClass: "ci-content-padding",
                              attrs: {
                                event: _setup.event,
                                loading: _setup.eventLoading,
                              },
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-tab",
                      {
                        attrs: {
                          title: _vm.$t(
                            "ui.views.start_page.header.tabs.products"
                          ),
                          active: _setup.viewMode === "products",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "start-page-container__mobile-view__products d-flex flex-column gap-3",
                          },
                          [
                            _c(_setup.FundSearch, {
                              staticClass: "ci-content-padding",
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.CiSuggestedExternalContent, {
                              staticClass: "pb-0",
                              attrs: {
                                id: `start_page_${
                                  _setup.CurrentUser.signedIn
                                    ? "logged_in"
                                    : "guest"
                                }_header_mobile_products`,
                                type: "display",
                                "member-ad": _setup.CurrentUser.signedIn,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.WatchlistCarousel, {
                              staticClass: "ci-card ci-content-padding",
                              attrs: {
                                watchlist: _setup.watchlistProducts,
                                "watchlist-count":
                                  _setup.watchlistProductsCount,
                                loading: _setup.watchlistLoading,
                              },
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.ComparisonsCarousel, {
                              staticClass: "ci-card ci-content-padding",
                              attrs: {
                                comparisons: _setup.comparisons,
                                "comparisons-count": _setup.comparisonsCount,
                                loading: _setup.comparisonsLoading,
                              },
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.PortfoliosCarousel, {
                              staticClass: "ci-card ci-content-padding",
                              attrs: {
                                portfolios: _setup.portfolios,
                                "portfolios-count": _setup.portfoliosCount,
                                loading: _setup.portfoliosLoading,
                              },
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                            _vm._v(" "),
                            _c(_setup.PartnerProducts, {
                              staticClass: "ci-content-padding",
                              attrs: {
                                products: _setup.partnerProducts,
                                loading: _setup.partnerProductsLoading,
                              },
                              on: {
                                "tracking-click": _setup.propagateTrackClick,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "start-page-container__mobile-view__products_news d-flex flex-column gap-3",
                  },
                  [
                    _c(_setup.CiUspComponent, {
                      staticClass: "ci-content-padding",
                    }),
                    _vm._v(" "),
                    _c(_setup.FundSearch, {
                      staticClass: "ci-content-padding",
                      on: { "tracking-click": _setup.propagateTrackClick },
                    }),
                    _vm._v(" "),
                    _c(_setup.CiSuggestedExternalContent, {
                      staticClass: "pb-0",
                      attrs: {
                        id: `start_page_${
                          _setup.CurrentUser.signedIn ? "logged_in" : "guest"
                        }_header_mobile_news`,
                        type: "display",
                        "member-ad": _setup.CurrentUser.signedIn,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "start_page-container__news" },
                      [
                        _c(_setup.News, {
                          staticClass: "ci-content-padding",
                          attrs: {
                            contents: _setup.startPageContents,
                            loading: _setup.newsLoading,
                          },
                          on: { "tracking-click": _setup.propagateTrackClick },
                        }),
                        _vm._v(" "),
                        _c(_setup.PartnerCarousel, {
                          staticClass: "pb-3 pb-md-4",
                          attrs: {
                            companies: _setup.partnerCompanies,
                            loading: _setup.companiesLoading,
                          },
                          on: { "tracking-click": _setup.propagateTrackClick },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(_setup.PartnerProducts, {
                      staticClass: "ci-content-padding",
                      attrs: {
                        products: _setup.partnerProducts,
                        loading: _setup.partnerProductsLoading,
                      },
                      on: { "tracking-click": _setup.propagateTrackClick },
                    }),
                  ],
                  1
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "start-page-container__main col-9 d-none d-xl-flex flex-column p-0 gap-3",
          },
          [
            !_setup.CurrentUser.signedIn
              ? _c(_setup.CiUspComponent, { staticClass: "ci-content-padding" })
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.FundSearch, { staticClass: "ci-content-padding" }),
            _vm._v(" "),
            _setup.CurrentUser.signedIn
              ? _c(_setup.ProductsTabs, {
                  staticClass: "ci-content-padding",
                  attrs: {
                    "comparisons-loading": _setup.comparisonsLoading,
                    comparisons: _setup.comparisons,
                    "comparisons-count": _setup.comparisonsCount,
                    "portfolios-loading": _setup.portfoliosLoading,
                    portfolios: _setup.portfolios,
                    "portfolios-count": _setup.portfoliosCount,
                    "watchlist-loading": _setup.watchlistLoading,
                    "watchlist-products": _setup.watchlistProducts,
                    "watchlist-products-count": _setup.watchlistProductsCount,
                  },
                  on: { "tracking-click": _setup.propagateTrackClick },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.CiSuggestedExternalContent, {
              staticClass: "pb-0",
              attrs: {
                id: `start_page_${
                  _setup.CurrentUser.signedIn ? "logged_in" : "guest"
                }_header_desktop`,
                type: "display",
                "member-ad": _setup.CurrentUser.signedIn,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "start_page-container__news" },
              [
                _c(_setup.News, {
                  staticClass: "ci-content-padding",
                  attrs: {
                    contents: _setup.startPageContents,
                    loading: _setup.newsLoading,
                  },
                  on: { "tracking-click": _setup.propagateTrackClick },
                }),
                _vm._v(" "),
                _c(_setup.PartnerCarousel, {
                  staticClass: "pb-4",
                  attrs: {
                    companies: _setup.partnerCompanies,
                    loading: _setup.companiesLoading,
                  },
                  on: { "tracking-click": _setup.propagateTrackClick },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(_setup.PartnerProducts, {
              staticClass: "ci-content-padding",
              attrs: {
                products: _setup.partnerProducts,
                loading: _setup.partnerProductsLoading,
              },
              on: { "tracking-click": _setup.propagateTrackClick },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "start-page-container__sidebar col-3 d-none d-xl-flex flex-column p-0 gap-3",
          },
          [
            _c(_setup.CiSuggestedExternalContent, {
              staticClass: "pb-0",
              attrs: {
                id: `start_page_${
                  _setup.CurrentUser.signedIn ? "logged_in" : "guest"
                }_sidebar_top`,
                type: "display",
                "member-ad": _setup.CurrentUser.signedIn,
              },
            }),
            _vm._v(" "),
            _setup.CurrentUser.signedIn
              ? _c(_setup.Notifications, {
                  staticClass: "flex-grow-1",
                  on: { "tracking-click": _setup.propagateTrackClick },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.CiSuggestedExternalContent, {
              staticClass: "pb-0",
              attrs: {
                id: `start_page_${
                  _setup.CurrentUser.signedIn ? "logged_in" : "guest"
                }_sidebar_2nd`,
                type: "display",
                "member-ad": _setup.CurrentUser.signedIn,
              },
            }),
            _vm._v(" "),
            _setup.CurrentUser.signedIn
              ? _c(_setup.Event, {
                  staticClass: "ci-content-padding",
                  attrs: { event: _setup.event, loading: _setup.eventLoading },
                  on: { "tracking-click": _setup.propagateTrackClick },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }